import { AUTH_USER_TOKEN_KEY, CONSULT_URL } from './Constants';
import { Auth } from 'aws-amplify';
import jwtDecode from 'jwt-decode';
import { getSubToken } from 'utils/api';
import QUERIES from 'graphql/queries';
import { graphQlCall } from 'graphql/utils';

const SUB_REFRESH_TOKEN_NAME = 'SUB_REFRESH_TOKEN_NAME';
const SUB_TOKEN_NAME = 'SUB_TOKEN_NAME';

export const validateToken = (token) => {
  return new Promise(async (resolve, reject) => {
    if (!token) {
      reject("Token is Empty");
    }
    try {
      let pureToken = token;
      if (token.includes('Bearer')) {
        const arr = token.split(' ');
        pureToken = arr[1];
      }
      const decodedJwt = jwtDecode(pureToken);

      if(decodedJwt.exp >= Date.now() / 1000){
        resolve(token);
      }
      else{
        refreshToken()
        .then( newToken => resolve( newToken ))
        .catch( error => reject( error ))
      }
    } catch (e) {
      return false;
    }
  })
};

export const username = (token) => {
  if (!token) {
    return '';
  }
  try {
    const decodedJwt = jwtDecode(token);
    return decodedJwt.username;
  } catch (e) {
    return '';
  }
};

export const refreshToken = ()=>{
  return new Promise(async (resolve, reject) => {
    const subAccountToken = getSubToken();
    try {
      if (subAccountToken) {
        const oldRefreshToken = getSubRefreshToken();
          const { token, refreshToken } = await graphQlCall({
            queryTemplateObject: QUERIES.REFRESH_TOKEN,
            values: {
              refreshToken: oldRefreshToken
            },
          });
          storeSubToken(token);
          storeSubRefreshToken(refreshToken);
          resolve(token);
      } else {
        let user = await Auth.currentAuthenticatedUser();
        let refreshToken = user.getSignInUserSession().getRefreshToken();      
        user.refreshSession(refreshToken, (refErr, refSession) => {
          if (refErr) {
            console.error(refErr);
            reject(refErr);
          }
          else{
            localStorage.setItem(
              AUTH_USER_TOKEN_KEY,
              refSession.accessToken.jwtToken
            );
            resolve(refSession.accessToken.jwtToken);
          }
        });
      }
    } catch (error) {
      window.open(`${CONSULT_URL}/console/login`, '_self');
    }
  });
}

export const storeSubToken = (token) => {
  localStorage.setItem(SUB_TOKEN_NAME, token);
}

export const getSubRefreshToken = () => {
  const token = localStorage.getItem(SUB_REFRESH_TOKEN_NAME);
  if (!token) {
    throw new Error('sub refresh token not exists');
  }
  return token;
}

export const storeSubRefreshToken = (refreshToken) => {
  localStorage.setItem(SUB_REFRESH_TOKEN_NAME, refreshToken);
}